<template>
  <div class="administrator-page">
    <div class="page-head">
      <div class="left">
        <h1>Administrator</h1>
      </div>
      <div class="right">
        <Button icon="md-person-add" type="info" @click="handleAddAdministrator"
          >Add New</Button
        >
      </div>
    </div>
    <AdministratorList ref="AdministratorList" @update="handleUpdate" @setList="setList" />
    <AdministratorForm ref="AdministratorForm"  @onSubmitResponse="onSubmitResponse" :administrators="administrators"/>
  </div>
</template>

<script>
import AdministratorList from "@/components/Administrator/AdministratorList";
import AdministratorForm from "@/components/Administrator/AdministratorForm";

export default {
  name: "Administrator",
  data(){
    return{
      administrators:[]
    }
  },
  components: {
    AdministratorList,
    AdministratorForm
  },

  methods: {
    setList(data){
      this.administrators=data
    },
    handleAddAdministrator() {
      this.$refs.AdministratorForm.triggerModal();
    },
    handleUpdate(data) {
      this.$refs.AdministratorForm.triggerUpdateModal(data);
    },
    onSubmitResponse(){
      this.$refs.AdministratorList.getAdministratorsList()
    }
  },
  mounted() {}
};
</script>

<style scoped></style>
